var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-1200 -1200 3000 3000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svelte-zyxd38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.926 0.754768L509.702 139.936V221.027L255.926 81.8465V0.754768Z",
    fill: "#FF7C00",
    fillOpacity: 0.4,
    className: "svelte-zyxd38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.69 139.936L254.981 279.641V361.255L509.69 221.55V139.936Z",
    fill: "#FF7C00",
    className: "svelte-zyxd38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.250138 139.937L254.981 279.641V361.255L0.250138 221.55V139.937Z",
    fill: "#FF7C00",
    fillOpacity: 0.4,
    className: "svelte-zyxd38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.923 0.232622L0.236328 139.936V221.55L255.923 81.8469V0.232622Z",
    fill: "#FF7C00",
    className: "svelte-zyxd38"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    id: "toup",
    type: "translate",
    from: "-124.964 140",
    to: "-124.964 0",
    dur: "0.5s",
    begin: "0;toleft.end",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    id: "toright",
    type: "translate",
    from: "-124.964 0",
    to: "124.964 0",
    dur: "0.5s",
    begin: "toup.end",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    id: "todown",
    type: "translate",
    from: "124.964 0",
    to: "124.964 140",
    dur: "0.5s",
    begin: "toright.end",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    id: "toleft",
    type: "translate",
    from: "124.964 140",
    to: "-124.964 140",
    dur: "0.5s",
    begin: "todown.end",
    fill: "freeze"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.926 141.5L509.702 280.681V361.773L255.926 222.592V141.5Z",
    fill: "#FF7C00",
    fillOpacity: 0.4,
    className: "svelte-zyxd38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.69 280.679L254.981 420.384V501.998L509.69 362.293V280.679Z",
    fill: "#FF7C00",
    className: "svelte-zyxd38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.250138 280.681L254.981 420.386V502L0.250138 362.295V280.681Z",
    fill: "#FF7C00",
    fillOpacity: 0.4,
    className: "svelte-zyxd38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.923 140.977L0.236328 280.68V362.294L255.923 222.591V140.977Z",
    fill: "#FF7C00",
    className: "svelte-zyxd38"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    id: "toDown",
    type: "translate",
    from: "124.964 -140",
    to: "124.964 0",
    dur: "0.5s",
    begin: "0;toRight.end",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    id: "toLeft",
    type: "translate",
    from: "124.964 0",
    to: "-124.964 0",
    dur: "0.5s",
    begin: "toDown.end",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    id: "toUp",
    type: "translate",
    from: "-124.964 0",
    to: "-124.964 -140",
    dur: "0.5s",
    begin: "toLeft.end",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    id: "toRight",
    type: "translate",
    from: "-124.964 -140",
    to: "124.964 -140",
    dur: "0.5s",
    begin: "toUp.end",
    fill: "freeze"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.d4ab9139a5a49802c9cace432b0954f2.svg";
export { ForwardRef as ReactComponent };